import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { getProtectedResource } from "../../services/apiRequest.service";
import { NestedResponseData } from "../../models/responseData";
import {
  TransformedData,
  transformDataBarChart
} from "../../utils/transformDataUtils";
import FilterDropdown from "../../components/FilterDropdown";
import DoubleBarChart from "../../charts/doubleBarChart/DoubleBarChart";
import InstitutionN from "../../components/InstitutionN";
import PageLoader from "../../components/PageLoader";
import ApiResponseToCSVConverter from "../../utils/csvDownload/ApiResponseToCsvConverter";
import { determineResponseTypeNestedResponseData } from "../../utils/determineResponseType";

const EmploymentStatus = () => {
  const [selectedFilter, setSelectedFilter] = useState("exit_status");
  const [apiResponse, setApiResponse] = useState<NestedResponseData | null>(null);
  const [transformedResponse, setTransformedResponse] = useState<TransformedData[] | null>(null);
  const [institutionN, setInstitutionN] = useState(0);

  const { getAccessTokenSilently } = useAuth0();
  const { year } = useParams();

  useEffect(() => {

    const getDataSectionA = async () => {
      const accessToken = await getAccessTokenSilently();
      const requestUrl = `section3/subsection3/?report_year=${year}&group_by=${selectedFilter}`;

      let { data, error } = await getProtectedResource(accessToken, requestUrl);

      if (data && determineResponseTypeNestedResponseData(data)) {
        setApiResponse(data);
        setTransformedResponse(transformDataBarChart(data, "3.3", selectedFilter));
        setInstitutionN(data.institution.total.total);
      }

      if (error) {
        console.error("Error fetching data:", error);
      }
    };

    getDataSectionA();
  }, [getAccessTokenSilently, selectedFilter, year])


  return (
    <>
      <h2>
        3.3 Employment status of spouses/partners
      </h2>
      <p>
        What was the employment status of the spouses/partners of departures and retentions at the time of the outside offer?
      </p>
      <p>
        Note: The categories are not mutually exclusive.
      </p>

      {!transformedResponse && <PageLoader />}

      {transformedResponse &&
        <>
          <InstitutionN institutionN={institutionN} />
          <FilterDropdown setSelectedFilter={setSelectedFilter} />
          <DoubleBarChart
            data={transformedResponse}
            selectedFilter={selectedFilter}
            institutionN={institutionN}
          />
          <ApiResponseToCSVConverter
            apiResponse={apiResponse}
            selectedFilter={selectedFilter}
            filename="3.3_Employment_status"
            section="3.3"
          />
        </>
      }

      
    </>
  )
}

export default EmploymentStatus;